import { IVENTIS_LOGO } from "@iventis/utilities";
import React, { FunctionComponent } from "react";
import styled from "@emotion/styled";
import { Header7 } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";

export const PoweredByIventisLogoComponent: FunctionComponent<{ className: string }> = ({ className }) => {
    const translate = useIventisTranslate();
    return (
        <StyledDiv className={className}>
            <Header7>{translate(Content.common.powered_by).toUpperCase()}</Header7>
            <StyledLogo src={IVENTIS_LOGO} alt="Iventis logo" />
        </StyledDiv>
    );
};

const StyledDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    h6 {
        letter-spacing: 1.2px;
    }
`;

const StyledLogo = styled.img`
    display: flex;
    height: 20px;
`;
